import React, { useContext, useEffect, useState } from "react";
import "./CancellationPopup.scss";
import AppContext from "../../config/AppContext";
import { ReactComponent as FailedsubIcon } from "../../assets/images/ralvie/failedsub.svg";
import { sidebarContext } from "../../util/context";
import { cancelSubscription } from "../../services/Subscription";
import { useTranslation } from "react-i18next";

const CancellationPopup = ({ open, onClose, onConfirm, selectedReason, setSelectedReason, otherReason, setOtherReason }) => {
  const { mode } = useContext(AppContext);
  const { subscriptionDetails } = useContext(sidebarContext);
  const { t } = useTranslation();

  const handleRetry = () => {
    if (onConfirm) {
      onConfirm();
      setSelectedReason(null);
      setOtherReason("");
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains("backdrop")) {
      onClose();
      setSelectedReason([]);
      setOtherReason("");
    }
  };

  const handleClose = () => {
    setSelectedReason(null);
    setOtherReason("");
    onClose();
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        handleRetry();
      } else if (event.key === "Escape" && open) {
        onClose();
      }
    };

    if (open) {
      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, onConfirm]);

  return (
    <div className="backdrop" onClick={handleBackdropClick}>
      <div
        className={mode === "dark" ? "popup-containerDark" : "popup-container"}
      >
        <div className="popup-icon">
          <FailedsubIcon />
        </div>
        <div className="title-container">
          <span className={mode === "dark" ? "popup-titleDark" : "popup-title"}>
            {t("RAL0894")}
          </span>
        </div>
        <div className="popup-messagecontainer">
          <span
            className={mode === "dark" ? "popup-messageDark" : "popup-message"}
          >
            {t("RAL0895")}
          </span>
        </div>
        <div className="popup-footercancellation">
          <button
            className={mode === "dark" ? "footercancelDark" : "footercancel"}
            onClick={handleClose}
          >
            {t("RAL0177")}
          </button>
          <button className="footerconfirm" onClick={handleRetry}>
            {t("RAL0896")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancellationPopup;
